import { jsx as c, jsxs as h } from "react/jsx-runtime";
import { labelVariants as i } from "./Label.variants.js";
const _ = ({
  as: r,
  className: l,
  children: t,
  fontWeight: m,
  iconEnd: n,
  iconStart: s,
  id: d,
  noWrap: e = !1,
  size: f = i.definition().defaultVariants.size,
  ...N
}) => {
  const { root: x, icon: b, container: j } = i, a = (V) => /* @__PURE__ */ c("span", { className: b(), children: V }), o = !!n || !!s || e, p = s && a(s), u = n && a(n), C = o ? /* @__PURE__ */ c("span", { className: j({ noWrap: e }), children: t }) : t;
  return /* @__PURE__ */ h(
    r,
    {
      className: x({
        className: l,
        fontWeight: m,
        size: f,
        _isContentWrapperNeeded: o
      }),
      id: d,
      ...N,
      children: [
        p,
        C,
        u
      ]
    }
  );
};
export {
  _ as Label
};
